

































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mapMutations, mapState } from "vuex";
import { BOOKING_PURPOSES } from "@/constants/booking";

@Component({
  computed: {
    ...mapState("QuestionnaireAnswer", {
      candidateReport: "report"
    })
  },
  methods: {
    ...mapMutations("QuestionnaireAnswer", {
      setReportPage: "SET_REPORT_PAGE",
      setQuestionGroupIndex: "SET_QUESTION_GROUP_INDEX"
    })
  }
})
export default class BookingReportCandidateInfo extends Vue {
  @Prop() readonly index!: string;
  @Prop() readonly report!: any;

  candidateReport!: any;

  bookingPurposes = BOOKING_PURPOSES;

  setReportPage!: (v: number) => void;
  setQuestionGroupIndex!: (v: number) => void;

  get hasQuestionGroupsWithConcerns() {
    return (
      this.report?.question_groups_have_concerns &&
      Object.keys(this.report?.question_groups_have_concerns).length > 0
    );
  }

  goToQuestionGroup(objectId) {
    this.setReportPage(3);
    const index = this.candidateReport.pages[3].question_groups.findIndex(
      questionGroup => questionGroup.object_id === objectId
    );
    this.setQuestionGroupIndex(index);
  }
}
